import React, { useEffect } from 'react'
import { ModalBody, ModalHeader } from 'reactstrap'

import Lang from 'Lang/General'

function MediaContent(props) {

  return (
    <>
      <ModalHeader toggle={ () => props.onClose() } >
        { Lang['MEDIA'][ props.data.languageReducer.userSettings.admin_panel_language ] }
      </ModalHeader>
      <ModalBody>
      </ModalBody>
    </>
  )
}

export default MediaContent